import {client} from './services/webservices-client'

export  const payments = {
    namespaced:true,
    state:{
        transaction:undefined,
        error:false,
        message:'',
        means_of_paiements:undefined,
        transactions:undefined,
        pending_transactions:undefined,
        failed_transactions:undefined,
        success_transactions:undefined,
        refunded_transactions:undefined,
        journals: undefined,
        templates:undefined,
        client_secret:undefined,
        full_transaction:undefined

    },
    mutations: {
        SET_TRANSACTION (state,transaction){
            state.transaction = transaction
        },
        SET_FULL_TRANSACTIONS (state,transaction){
            state.full_transaction = transaction
        },
        SET_CLIENT_SECRET(state,client_secret){
            state.client_secret = client_secret
        },
        SET_MEANS_OF_PAIEMENTS (state,means_of_paiements){
            state.means_of_paiements = means_of_paiements
        },
        SET_ERROR(state,error){
            state.error = error;
        },
        SET_TEMPLATES(state,templates){
            state.templates = templates;
        },
        SET_MESSAGE(state,message){
            state.message = message;
        },
        SET_TRANSACTIONS (state,transactions){
            state.transactions = transactions
        },
        SET_JOURNALS (state,journals){
            state.journals = journals
        },
        SET_PENDIND_TRANSACTIONS (state,pending_transactions){
            state.pending_transactions = pending_transactions
        },
        SET_FAILED_TRANSACTIONS (state,failed_transactions){
            state.failed_transactions = failed_transactions
        },
        SET_SUCCESS_TRANSACTIONS (state,success_transactions){
            state.success_transactions = success_transactions
        },
        SET_REFUNDED_TRANSACTIONS (state,refunded_transactions){
            state.refunded_transactions = refunded_transactions
        },
    },
    actions: {
        createTransaction({commit},datas){
            alert("ici")
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/v1/widget/payments/request',
                    data:datas
                }).then((response)=>{
                    commit('SET_TRANSACTION',response.data.transaction);
                    if (response.data.error){
                        commit('SET_ERROR',response.data.error)
                        commit('SET_MESSAGE',response.data.message)
                    }
                    resolve(response.data)
                }).catch((error)=>{
                    reject(error);
                })
            })
        },
        getTransaction({commit},transaction_id){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/v1/transactions/get/'+transaction_id,
                }).then((response)=>{
                        commit('SET_TRANSACTION',response.data.transaction);
                        if (response.data.error){
                            commit('SET_ERROR',response.data.error)
                            commit('SET_MESSAGE',response.data.message)
                        }
                        resolve(response.data)
                }).catch((error)=>{
                        reject(error);
                    })
            })
        },
        getPaymentGateTransaction({commit},transaction_id){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/v1/transactions/get/gate/'+transaction_id,
                }).then((response)=>{
                        commit('SET_TRANSACTION',response.data.transaction);
                        commit('SET_MEANS_OF_PAIEMENTS',response.data.means_of_paiements);
                        commit('SET_TEMPLATES',response.data.templates);
                        commit('SET_CLIENT_SECRET',response.data.client_secret);
                        if (response.data.error){
                            commit('SET_ERROR',response.data.error);
                            commit('SET_MESSAGE',response.data.message)
                        }
                        resolve(response.data)
                }).catch((error)=>{
                        reject(error);
                    })
            })
        },
        updateGateTransaction({commit},datas){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/v1/payments/update/transaction',
                    data:datas
                }).then((response)=>{
                    commit('SET',3);
                    resolve(response.data)
                }).catch((error)=>{
                        reject(error);
                    })
            })
        },
        refundTransaction({commit},datas){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/v1/refund/transaction',
                    data:datas
                }).then((response)=>{
                    commit('SET',3);
                    resolve(response.data)
                }).catch((error)=>{
                        reject(error);
                    })
            })
        },
        /* eslint-disable */
        updateTransaction({commit},data){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/v1/payments/update',
                    data:data,
                })
                    .then((response)=>{
                        resolve(response.data);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            });
        },
        getUSerTransactions({commit},data){
            commit('SET_TRANSACTIONS',undefined);
            return new Promise((resolve,reject)=>{
                let path = (data.marchand_id)?'marchand/'+data.marchand_id:'admin';
                client({
                    method : 'post',
                    url:'/v1/transactions/get/by/'+path+data.filter,
                    data:data,
                }).then((response)=>{
                    commit('SET_TRANSACTIONS',response.data.transactions);
                    resolve(response.data)
                }).catch((error)=>{
                    reject(error);
                })
            })
        },
        getUSerTransactionsForCsvTransactions({commit},data){
            commit('SET_FULL_TRANSACTIONS',undefined);
            return new Promise((resolve,reject)=>{
                let path = (data.marchand_id)?'marchand/'+data.marchand_id:'admin';
                client({
                    method : 'post',
                    url:'/v1/transactions/full/get/by/'+path+data.filter,
                    data:data,
                }).then((response)=>{
                    commit('SET_FULL_TRANSACTIONS',response.data.transactions);
                    resolve(response.data)
                }).catch((error)=>{
                    reject(error);
                })
            })
        },
        getUserJournals({commit},marchand_id){
            return new Promise((resolve,reject)=>{
                let marchand = (marchand_id)?marchand_id:'';
                client({
                    method : 'get',
                    url:'/v1/journals/get/by/marchand/'+marchand,
                }).then((response)=>{
                    commit('SET_JOURNALS',response.data.journals);
                    resolve(response.data)
                }).catch((error)=>{
                    reject(error);
                })
            })
        },

    },
    getters: {}
};
